import type { TOC } from '@ember/component/template-only'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { t } from 'ember-intl'
import { CaseStudyTile } from 'teacher-ui-client/components/case-study-tile'
import type CaseStudiesController from 'teacher-ui-client/subscription-type/quick-links/case-studies/controller'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    controller: CaseStudiesController
  }
}
export const QuickLinksCaseStudiesPage: TOC<Signature> = <template>
  <div class="w-full">
    <PageHeader>
      <:title>
        <h1>
          {{t "quick-links.caseStudies.pageTitle"}}
        </h1>
      </:title>
    </PageHeader>

    <div class="mx-6 flex w-full flex-wrap">
      {{#each @controller.caseStudies as |caseStudy|}}
        <CaseStudyTile
          @title={{caseStudy.title}}
          @description={{caseStudy.description}}
          @coverUrl={{caseStudy.coverUrl}}
          @fileUrl={{caseStudy.fileUrl}}
        />
      {{/each}}
    </div>
  </div>
</template>

export default RouteTemplate(QuickLinksCaseStudiesPage)
